import WebAuth from '@videsk/front-auth-handler';

const hostnameList = ['localhost', '127.0.0.1'];

const fromStorage = () => {
  const result = window.localStorage.getItem('debug-videsk');
  if (result) return JSON.parse(result);
  return {};
};

const configuration = Object.assign({
  apiUrl: (hostnameList.some(host => window.location.hostname.includes(host))) ? 'http://localhost:3030' : 'https://api.videsk.io',
}, fromStorage());

const options = {
  config: {
    endpoints: {
      hostname: configuration.apiUrl,
      accessToken: {
        url: '/auth/check-token',
        method: 'GET',
        authorizationType: 'Bearer',
        headers: {
          'Content-Type': 'application/json',
        },
        body: {},
        keys: {
          accessToken: 'accessToken',
          refreshToken: 'refreshToken',
        },
        status: {
          expired: 401,
          ok: 200,
        },
        attempts: 3,
      },
      refreshToken: {
        url: '/auth/refresh-token',
        method: 'POST',
        authorizationType: 'Bearer',
        headers: {
          'Content-Type': 'application/json',
        },
        body: {},
        keys: {
          accessToken: 'accessToken',
          refreshToken: 'refreshToken',
        },
        status: {
          expired: 401,
          ok: 201,
        },
        attempts: 3,
      },
    },
  },
};

const auth = new WebAuth(options);
export default auth;
